<template>
      <v-text-field
        v-model="answerDate"
        :label="question.text"
        :rules="[
            value => !!value || 'This field is required',
            value => value && value <= maxDate || 'Please enter an earlier date',
            value => value && value >= minDate || 'Please enter a later date',
          ]"
        type="date"
        :min="minDate"
        :max="maxDate"
      ></v-text-field>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import { DateTime } from 'luxon';

export default {
  name: 'input-rag-date',
  props: ['value', 'answerSet', 'customerId', 'singleLine', 'placeholder', 'question', 'page', 'box', 'dense'],
  data: () => ({
    answers: null,
    modal: false
  }),
  computed: {
    ...mapGetters(['GetAnswersForQuestion']),
    AnswerSetId() {
      return this.answerSet.id;
    },
    answerDate: {
      get() {
        return _.isUndefined(this.answerSet) ? null : this.answerSet.answer.answer_text;
      },
      set(value) {
        const monthsOld = moment().diff(moment(value), 'months');
        let answerId = null;

        if (!_.isNaN(value) && value !== null) {
          answerId = _.reduce(
            this.sortedAnswers,
            (answerId, answer) => (monthsOld >= answer.value ? answer.id : answerId),
            _.last(this.sortedAnswers).id
          );
        }

        if (moment(value).isValid()) {
          this.updateAnswerSet({
            id: this.customerId,
            answerSet: this.answerSet,
            answerId,
            answerText: moment(value).format('YYYY-MM-DD'),
            questionId: this.question.id,
            isCritical: this.question.is_critical
          });

          this.$emit('input', answerId);
        }
      }
    },
    minDate() {
      return typeof this.question.min_date !== undefined && this.question.min_date !== null
        ? DateTime.fromFormat(this.question.min_date, 'yyyy-MM-dd').toString()
        : '1900-01-01';
    },
    maxDate() {
      return typeof this.question.max_date !== undefined && this.question.max_date !== null
        ? DateTime.fromFormat(this.question.max_date, 'yyyy-MM-dd').toString()
        : new Date().toISOString().substr(0, 10);
    },
    sortedAnswers() {
      return _.orderBy(
        _.filter(this.question.answers, answer => answer.enabled === true),
        'value',
        'asc'
      );
    }
  },
  methods: {
    ...mapActions(['updateAnswerSet']),
  },
  watch: {
    modal(val) {
      val && setTimeout(() => (this.$refs.datePicker.activePicker = 'YEAR'), 0);
    }
  },
  mounted() {
    this.answers = this.question.answers;
  }
};
</script>

<style scoped></style>
